module.exports = __webpack_public_path__ + "static/media/10.16d96d91.svg";